export default __webpack_public_path__ + "static/media/cprofile3.58d55695.png";